import {
  INPUT_FIELD_TYPES,
  CONTACTS_FIELD_TYPES,
  COMMON_FIELD_TYPES,
  PAYMENTS_FIELD_TYPES,
  EVENTS_FIELD_TYPES,
  type InputFieldType,
  type InputFieldTypes,
  type ContactsInputFieldType,
  type CommonInputFieldType,
  type PaymentsInputFieldType,
  type EventsInputFieldType,
} from './input-field-types';
import {
  READONLY_FIELD_TYPES,
  type ReadonlyFieldTypes,
  type ReadonlyFieldType,
} from './readonly-field-types';
import { DEXT_FIELD_TYPES } from './dext-field-types';

export const FIELD_TYPES = {
  ...INPUT_FIELD_TYPES,
  ...READONLY_FIELD_TYPES,
  SUBMIT_BUTTON: 'SUBMIT_BUTTON',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type FIELD_TYPES = typeof FIELD_TYPES;

export type FieldType = keyof typeof FIELD_TYPES;

export type {
  InputFieldType,
  InputFieldTypes,
  ReadonlyFieldTypes,
  ReadonlyFieldType,
  ContactsInputFieldType,
  CommonInputFieldType,
  PaymentsInputFieldType,
  EventsInputFieldType,
};
export {
  INPUT_FIELD_TYPES,
  CONTACTS_FIELD_TYPES,
  COMMON_FIELD_TYPES,
  PAYMENTS_FIELD_TYPES,
  READONLY_FIELD_TYPES,
  DEXT_FIELD_TYPES,
  EVENTS_FIELD_TYPES,
};
